export function normalizeSubscriptionPayload(data) {
  if (!data) return null;
  const subscription = data.subscription || data;
  if (!subscription || typeof subscription !== "object") return null;

  let daysLeft =
    typeof data.daysLeft === "number"
      ? data.daysLeft
      : subscription.daysLeft ?? null;

  if (subscription.expiresAt) {
    const expiresAt = new Date(subscription.expiresAt).getTime();
    if (!Number.isNaN(expiresAt)) {
      daysLeft = Math.ceil((expiresAt - Date.now()) / (1000 * 60 * 60 * 24));
    }
  }

  return {
    ...subscription,
    isActive:
      typeof data.isActive === "boolean"
        ? data.isActive
        : !subscription.isCancelled && subscription.status === "PAID",
    daysLeft,
    subscriptionState: data.subscriptionState || null,
    actions: data.actions || null,
  };
}

export function isFreeTrialPlan(subscription) {
  if (!subscription) return false;
  const nameEn = String(subscription?.packageOption?.name_en || "").toLowerCase();
  const nameAr = String(subscription?.packageOption?.name_ar || "").toLowerCase();
  return (
    nameEn.includes("free trail") ||
    nameEn.includes("free trial") ||
    nameAr.includes("تجربة مجانية")
  );
}

export function needsRenewal(subscription) {
  if (!subscription) return false;

  const state = subscription.subscriptionState;
  if (["trial_expired", "expired", "inactive"].includes(state)) {
    return true;
  }

  if (typeof subscription.daysLeft === "number" && subscription.daysLeft <= 0) {
    return true;
  }

  return false;
}

export function isDashboardBlocked(subscription) {
  return needsRenewal(subscription);
}

export function getCheckoutUrl(response) {
  return (
    response?.checkout?.url ||
    response?.checkoutUrl ||
    response?.checkout_url ||
    null
  );
}
